export default {
	/**
	 * Get currently selected proposal object based on state.proposalId
	 */
	proposal: state => {
		const proposalId = state?.proposalId
		const proposal = state?.proposals?.find(item => item.id === proposalId)
		return proposal
	},

	/**
	 * Get currently selected offer object based on state.offerId
	 */
	offer: (state, getters) => {
		const offerId = state?.offerId
		const offer = getters?.proposal?.basket?.find(offer => offer.id === offerId)
		return offer
	}
}
